/**
 * Subscribes to socket `notification` and shows an in-app toast banner with optional deep link.
 */

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSocket } from '../../utils/SocketContext';
import { getNotificationLabel, getNotificationLink } from '../../helpers/notificationsHelpers';

const MESSAGE_NOTIFICATION_TYPES = new Set(['dm_message', 'group_message', 'club_message']);

function NotificationBannerBridge() {
  const { subscribe, connected } = useSocket();

  useEffect(() => {
    if (!connected) return;
    return subscribe('notification', (payload) => {
      const n = payload?.notification;
      if (!n) return;
      if (MESSAGE_NOTIFICATION_TYPES.has(n.notification_type_id)) return;
      const label = getNotificationLabel(n);
      const to = getNotificationLink(n);
      toast.custom(
        (t) => (
          <div className="max-w-sm rounded-xl border border-shadow bg-charcoal px-4 py-3 shadow-lg">
            {to ? (
              <Link
                to={to}
                className="text-sm font-medium text-ash hover:text-ether"
                onClick={() => toast.dismiss(t.id)}
              >
                {label}
              </Link>
            ) : (
              <p className="text-sm font-medium text-ash">{label}</p>
            )}
          </div>
        ),
        { duration: 6000, position: 'top-center' }
      );
    });
  }, [connected, subscribe]);

  return null;
}

export default NotificationBannerBridge;
